module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackCondIt.276e9c0.ttf";